module.exports = __webpack_public_path__ + "img/ic-cross.8d58e7a9.svg";